import Route from '@ember/routing/route'

export default class BookingRoute extends Route {}
